<template>
    <v-dialog v-if="dialog" v-bind="$attrs" v-on="$listeners">
        <slot />
    </v-dialog>
    <toolbox-window v-else-if="toolbox" v-bind="$attrs" v-on="$listeners">
        <slot />
    </toolbox-window>
    <v-bottom-sheet v-else v-bind="$attrs" v-on="$listeners">
        <slot />
    </v-bottom-sheet>
</template>

<script>
import ToolboxWindow from './ToolboxWindow.vue'
export default {
    name: 'zoezi-bottom-dialog',
    props: ['dialog', 'toolbox'],
    zoezi: {
        title: 'Bottom dialog',
        internal: true
    },

    components: { ToolboxWindow }
}
</script>
